export default {"src":"/_next/static/media/errorSign.d62c6769.svg","height":24,"width":6,"blurWidth":0,"blurHeight":0};